// ============================================================================
// CLOSURE REASON ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CLOSURE_REASON_BASE_PATH = '/ClosureReason';

export const closureReasonEndpoints = {
  list: () => buildEndpoint(CLOSURE_REASON_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${CLOSURE_REASON_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${CLOSURE_REASON_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(CLOSURE_REASON_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${CLOSURE_REASON_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${CLOSURE_REASON_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${CLOSURE_REASON_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default closureReasonEndpoints;
